import axios from 'axios';

import wos from 'apis/wos';

import { SMARTY_API_PUBLIC_KEY } from 'utils/globals';

import type {
  SavedAddress,
  SmartyStreetResponse,
  ValidationAPIOutputAddress,
  ValidationAPIInputAddress,
} from './addresses.types';

/**
 * Fetches all the user's saved addresses
 */
export const all = async () => {
  const response = await wos.get<SavedAddress[]>('/addresses.json', {
    params: { addresstype: 'S', default: true },
  });
  return response.data;
};

/**
 * Validates the given address against the FedEx API
 */
export const validate = async (address: ValidationAPIInputAddress) => {
  const { data } = await wos.get<ValidationAPIOutputAddress>('/validate_address.json', {
    params: { ...address },
  });

  return data;
};

/**
 * Looks up a city/state for a given zip code
 */
export const zipLookup = async (zip: string) => {
  const url = `https://us-zipcode.api.smartystreets.com/lookup?key=${SMARTY_API_PUBLIC_KEY}&zipcode=${zip}`;
  const { data } = await axios.get<SmartyStreetResponse[]>(url, {
    headers: { 'Content-Type': 'application/json' },
  });

  return data;
};
